export enum PermissionProducts {
  Competitions = "competitions",
  TeamManager = "teamManager",
}
